import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Validator from 'validatorjs'
import moment from 'moment'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import DeleteNotification  from './DeleteNotification'

import Input from 'components/Input'
import TextArea from 'components/TextArea'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'

import { CLAIM_UPDATES } from 'constants'


export  class Notification extends BaseComponent {
  static validationRules = {
    title: 'string|required|min:2',
    content: 'string|required|min:5',
  }

  constructor(props) {
    super()

    this.state = {
      buttonProps: {
        disabled: false
      },
      editting: false,
      formData: {
        title: props.notification.title,
        content: props.notification.content
      }
    }

    this._bind( '_showDeleteConfirmation', '_handleChange', '_onEdit', '_renderData',
                '_renderEditForm','_validate', '_handleSubmit', '_renderSMS')
  }

  _showDeleteConfirmation(id) {
    this.context.toggleModal(true,
      <DeleteNotification notification={this.props.notification} claimId={this.props.claimId} notificationId={id}/>
    )
  }

  _onEdit() {
    this.setState({ editting: true })
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    const formData = {
      ...this.state.formData,
      [name]: value
    }
    const validator = new Validator(formData, Notification.validationRules)
    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  _handleSubmit(e) {
    e.preventDefault()
    const url =  `${CLAIM_UPDATES(this.props.claimId)}${this.props.notification.id}/`
    this.props.updateRequestStatus('progress', 'Actualizando notificación...')
    request(url, {
      method: 'PATCH',
      body: {
        ...this.state.formData
      }
    })
      .then((res) => {
        this.props.updateRequestStatus('ok', 'Notificación Editada')
      })
      .catch((err) => {this.props.updateRequestStatus('error', 'No pudimos editar la notificación')})

    this.setState({
      editting: false
    })

  }

  _renderSMS(){
    return (this.props.notification.has_sms) ? (
      <span>
        <p className="content">SMS: {this.props.notification.sms_content}</p>
      </span> 
    ) : null
  }

  _renderData() {
    const notification = this.state.formData
    return (
      <div>
        <p className="title">{notification.title}</p>
        <p className="content">{notification.content}</p>
        {this._renderSMS()}
      </div>
    )
  }

  _renderEditForm() {
    return (
      <form onSubmit={this._handleSubmit}>
        <Input  label="Titulo"
                onChange={this._handleChange}
                value={this.state.formData.title}
                name="title" />

        <TextArea  label="Contenido"
                onChange={this._handleChange}
                value={this.state.formData.content}
                name="content" />

        <Button className="editNotificationButton"
                buttonType="primary"
                type="submit"
                size="big" {...this.state.buttonProps}>Modificar</Button>
      </form>
    )
  }

  render() {
    const images = {
      noImage: require('img/users/notUser.gif')
    }
    const notification = this.props.notification
    const date = moment(notification.created)
    const dateElement = date.format('DD-MM-YYYY')
    const timeComponent = date.format('HH:mm')  

    const profilePhoto = notification.sent_by.picture || images.noImage
    const bgImage = {
      'backgroundImage': `url(${profilePhoto})`
    }
    const name = `${notification.sent_by.first_name} ${notification.sent_by.last_name}`

    return (
      <li className="NotificationItem">
        <div className="disc"></div>
        <i  className="delete-button material-icons"
            onClick={() => { this._showDeleteConfirmation(notification.id)}}>delete</i>
        <i className="edit-button material-icons" onClick={this._onEdit}>edit</i>
        <div className="NotificationItem__time">
          <p className="date">{dateElement}</p>
          <p>{timeComponent}</p>
        </div>
        <div className="NotificationItem__body">
          {this.state.editting ? this._renderEditForm() : this._renderData() }

          <div className="d-flex align-items-center">
            <div className="NotificationItem__body__image" style={bgImage}></div>
            <p>Enviado por: <span>{name}</span></p>
          </div>
        </div>
      </li>
    )
  }
}


Notification.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}


const mapDispatchToProps = (dispatch) => {

  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(Notification)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notifications/NotificationList/Notification.js